<template lang="html">

  <div class="login container">
      <img class="center responsive-img" src="@/assets/images/hmy_claim.png"/>
      <form @submit.prevent="login" class="card-panel">
          <h2 class="center blue-text">Connexion</h2>
          <div class="field">
              <label for="phone">Téléphone:</label>
              <input type="text" name="phone" v-model="phone">
          </div>
          <h5 class="center blue-text">ou</h5>

          <div class="field">
                <label for="email">Email:</label>
                <input type="email" name="email" v-model="email">
          </div>
          <h5 class="center blue-text">et</h5>

          <div class="field">
              <label for="password">Mot de passe:</label>
              <input type="password" name="password" v-model="password">
          </div>
          <p v-if="feedback" class="red-text center">{{feedback}}</p>
          <div class="input-field center">
              <button class="btn light-blue">Se connecter</button>
          </div>
      </form>
  </div>
</template>

<script>
import db from '@/firebase/init'
import firebase from 'firebase'

export default {
    name: 'Login',
    data(){
        return{
            email: null,
            phone: null,
            password: null,
            feedback: null,
            user: null,
            isAdmin: null
        }
    },
    methods:{
        login(){
            if(this.phone && this.password){
                //retrieve user email from phone number
                let ref = db.collection('users').where('phone', '==', this.phone)
                ref.get().then(snapshot => {
                    snapshot.forEach(doc => {
                        this.user = doc.data()
                        this.user.id = doc.id
                        })
                })
                .then(() => {
                    firebase.auth().signInWithEmailAndPassword(this.user.email, this.password)
                    .then(cred =>{
                            //console.log(cred.user.uid)
                            // get current user from users collection
                            let ref = db.collection('users')
                            ref.where('user_id', '==', firebase.auth().currentUser.uid).get()
                            .then(snapshot => {
                                snapshot.forEach(doc => {
                                    this.user = doc.data()
                                    this.user.id = doc.id
                                })
                                if(this.user.active == false){
                                    this.feedback = 'Ce compte n\'est plus actif' 
                                }else{
                                    //console.log(this.user.role)
                                    //check if user is admin and redirect
                                    if(this.user.role == 'admin'){
                                        this.$router.push({ name: 'Admin'})
                                    }else{
                                        this.$router.push({ name: 'Home' })
                                    }
                                }
                            })
                        })
                        .catch(err => {
                            this.feedback = err.message
                        })
                        this.feedback = null
                    })

                }else{
                    this.feedback = 'Veuillez entrer un numéro de téléphone ou un email et un mot de passe'
                }
            if(this.email && this.password){
                firebase.auth().signInWithEmailAndPassword(this.email, this.password)
                .then(cred =>{
                    //console.log(cred.user.uid)
                    // get current user from users collection
                    let ref = db.collection('users')
                    ref.where('user_id', '==', firebase.auth().currentUser.uid).get()
                    .then(snapshot => {
                        snapshot.forEach(doc => {
                            this.user = doc.data()
                            this.user.id = doc.id
                        })
                       if(this.user.active == false){
                                    this.feedback = 'Ce compte n\'est plus actif.' 
                                }else{
                                    //console.log(this.user.role)
                                    //check if user is admin and redirect
                                    if(this.user.role == 'admin'){
                                        this.$router.push({ name: 'Admin'})
                                    }else{
                                        this.$router.push({ name: 'Home' })
                                    }
                                }
                    })
                })
                .catch(err => {
                    this.feedback = err.message
                })
                this.feedback = null
            }
        }
    }
}
</script>

<style lang="css" scoped>

.login{
    max-width: 400px;
    margin-top: 60px;
}
.login h2{
    font-size: 2.4em;
}
.login .field{
    margin-bottom: 16px;
}
.panel{
    box-shadow: none;
}
</style>
